export default {
  deskUnavailable: '2021-01/OasisUnavailable.png',
  flexOfficeUnavailable: '2021-01/FlexOfficeUnavailable.png',
};
